module.exports = __webpack_public_path__ + "img/rank-table-girl-1.64f2f386.jpg";